import React from 'react';
import PropTypes from 'prop-types';
function Tooltip(_ref) {
  var title = _ref.title,
    description = _ref.description;
  return /*#__PURE__*/React.createElement("div", {
    className: "welcome-text"
  }, /*#__PURE__*/React.createElement("h3", null, title), description);
}
Tooltip.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
};
export default Tooltip;